module.exports = __webpack_public_path__ + "media/images/top-content-img-3-0cea8a19d435ee98edb8a4b01eac4e14.jpg";